import BillingCmlBmCodeIndex from "@/components/billing_cml/bm-code-lkup/BmCodeIndex.vue";

let routesBmCodeAccess= [
    {
        path: '',
        meta: {
          title: "CML List BmCode",
        },
        name: "BillingCmlBmCodeIndex",
        component: BillingCmlBmCodeIndex
    },
    
]

export default routesBmCodeAccess
  